import Fetcher from "../utils/Fetcher";
import Consts from "../commons/Consts";
import Helpers from "../utils/Helpers";

const PublicService = {

    getSession(sess_id, params={}) {
        return Fetcher.get(`${Consts.baseapi}/public/sessions/${sess_id}?${Helpers.objToUrlParams(params, true, false)}`);
    },

    canEnroll(sess_id) {
        return Fetcher.get(`${Consts.baseapi}/public/sessions/${sess_id}/can-enroll`);
    },

    updateInvoiceStatus(token, status) {
        return Fetcher.put(`${Consts.baseapi}/public/invoices/${token}/${status}`);
    },

    checkInvoiceStatus(token) {
        return Fetcher.get(`${Consts.baseapi}/public/invoices/${token}`);
    },

    enroll(sess_id, data) {
        return Fetcher.post(`${Consts.baseapi}/public/sessions/${sess_id}/enroll`, data);
    },

    getPreparedPay(sess_id, candidateId, qty, params={}) {
        return Fetcher.get(`${Consts.baseapi}/public/sessions/${sess_id}/vote/${candidateId}/${qty}?${Helpers.objToUrlParams(params)}`);
    },

    sendGetQuery(url) {
        return Fetcher.get(url);
    },

    sendPostQuery(url, data) {
        return Fetcher.post(url, data);
    }

};

export default PublicService;
